import { ref } from 'vue'
import { useApi } from '@/api/useApi'
import API from '@/api/apiUrls'
import { defineStore } from 'pinia'
import type { UserType } from '@/stores/type/authDjango.type'
import { useShipAPI } from '@/api/useShipApi'
import { useSearchUserBaseStore } from '@haskoning/vue-basestore'

const { api } = useApi()
const { api: shipAPI } = useShipAPI()
const userIndex = API.CORE.USERS.INDEX
const currentUser = API.CORE.USERS.CURRENT_USER

export const useDjangoAuthStore = defineStore('auth', () => {
  const searchUserBaseStore = useSearchUserBaseStore<UserType>(api, userIndex)
  const user = ref<UserType | null>(null)

  async function authenticate({ email, password }: { email: string; password: string }) {
    await api.apiService.authenticationHandler.authenticate(email, password)
    const userResponse = await api.service(currentUser).get()
    user.value = userResponse
    return { user: userResponse }
  }

  const authenticateShipApi = async () => {
    const url = API.SHIP.SHIP_API.AUTH
    try {
      const response = await api.service(url).get()
      if (!response) {
        return
      }
      const accessToken = response.access
      const refreshToken = response.refresh
      if (accessToken && refreshToken) {
        localStorage.setItem('accessShipApi', accessToken)
        localStorage.setItem('refreshShipApi', refreshToken)
        await shipAPI.apiService.authenticationHandler.setAccessTokenInHeaderFromStore().then()
      }
    } catch (e) {
      console.log(e)
    }
  }

  async function reAuthenticate() {
    await api.apiService.authenticationHandler.setAccessTokenInHeaderFromStore()
    try {
      const userResponse = await api.service(currentUser).get()
      user.value = userResponse
      return { user: userResponse }
    } catch (e) {
      user.value = null
      return { user: null }
    }
  }

  function logout() {
    localStorage.removeItem('access')
    localStorage.removeItem('refresh')
    localStorage.removeItem('accessShipApi')
    localStorage.removeItem('refreshShipApi')
    user.value = null
  }

  return {
    ...searchUserBaseStore,
    user,
    authenticate,
    authenticateShipApi,
    reAuthenticate,
    logout
  }
})
